module.exports = __webpack_public_path__ + "static/columbiaLogo-83debd4fc71bb46e792da7c8e95ee75e.jpg";